/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Insert_ButtonInputs */

const en_tags_manager_insert_button = /** @type {(inputs: Tags_Manager_Insert_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert Tag`)
};

const fr_tags_manager_insert_button = /** @type {(inputs: Tags_Manager_Insert_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserer le tag`)
};

const de_tags_manager_insert_button = /** @type {(inputs: Tags_Manager_Insert_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag einfügen`)
};

const it_tags_manager_insert_button = /** @type {(inputs: Tags_Manager_Insert_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci tag`)
};

const ru_tags_manager_insert_button = /** @type {(inputs: Tags_Manager_Insert_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить тег`)
};

const es_tags_manager_insert_button = /** @type {(inputs: Tags_Manager_Insert_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar etiqueta`)
};

const zh_cn2_tags_manager_insert_button = /** @type {(inputs: Tags_Manager_Insert_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入标签`)
};

const ja_tags_manager_insert_button = /** @type {(inputs: Tags_Manager_Insert_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タグを挿入`)
};

const hi_tags_manager_insert_button = /** @type {(inputs: Tags_Manager_Insert_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टैग डालें`)
};

const pt_pt2_tags_manager_insert_button = /** @type {(inputs: Tags_Manager_Insert_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir etiqueta`)
};

/**
* | output |
* | --- |
* | "Insert Tag" |
*
* @param {Tags_Manager_Insert_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_insert_button = /** @type {((inputs?: Tags_Manager_Insert_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Insert_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_insert_button(inputs)
	if (locale === "de") return de_tags_manager_insert_button(inputs)
	if (locale === "it") return it_tags_manager_insert_button(inputs)
	if (locale === "ru") return ru_tags_manager_insert_button(inputs)
	if (locale === "es") return es_tags_manager_insert_button(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_insert_button(inputs)
	if (locale === "ja") return ja_tags_manager_insert_button(inputs)
	if (locale === "hi") return hi_tags_manager_insert_button(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_insert_button(inputs)
	return en_tags_manager_insert_button(inputs)
});